module.exports = __webpack_public_path__ + "img/V18.fbec3b3a.png";